'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // Compatibility wrapper to fit the winres-transport component
// into the old model winres-reservation-context way of doing
// things.

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var log = (0, _utils.getLog)('[TransportWrapper]');

var WinresTransportWrapperController = function () {
    function WinresTransportWrapperController($scope) {
        _classCallCheck(this, WinresTransportWrapperController);

        this.$scope = $scope;
    }

    _createClass(WinresTransportWrapperController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.beginDate = null;
            this.endDate = null;
            this.destCode = null;

            // The user can choose "no route at all" if the transport group is optional.
            // In that case, we need some way to keep track of these routes between
            // sessions, since no actual product lines are created for them.
            // Thus, track them here.
            this.noneRouteLines = [];

            this.data = this.winresReservationContext.getContext();

            log('Existing product lines on init:', _.cloneDeep(this.data.Products));

            this.$scope.$watch(function () {
                return _this.data.SelectedDeparture;
            }, function () {
                return _this.loadDeparture();
            }, true);
            this.$scope.$watch(function () {
                return _this.data.Passengers;
            }, function () {
                return _this.loadPassengers();
            }, true);
            this.$scope.$watch(function () {
                return _this.data.Products;
            }, function (lines) {
                return _this.loadProductLines();
            }, true);
        }
    }, {
        key: 'loadDeparture',
        value: function loadDeparture() {
            var dep = this.data.SelectedDeparture;
            if (dep) {
                // console.log('[WinresTransportWrapper] Detected departure:', dep);
                this.beginDate = dep.DepartureDate;
                this.endDate = dep.ArrivalDate2;
                this.destCode = dep.DestinationCode;

                // Transport from session
                var trans = this.data.Transport;
                if (trans && trans.DestinationCode === dep.DestinationCode && trans.DepartureDate === dep.DepartureDate && trans.ArrivalDate2 === dep.ArrivalDate2) {
                    this.createProducts(trans.Products);
                    // If there are any none-routes, load them directly instead
                    // of making real lines out of them.
                    this.noneRouteLines = _.isArray(trans.NoneRouteLines) ? trans.NoneRouteLines : [];
                    log('Found', this.noneRouteLines.length, 'none routes.');
                }
            }
        }
    }, {
        key: 'loadPassengers',
        value: function loadPassengers() {
            var pass = this.winresReservationContext.getPassengersForPricing();
            if (pass && pass.length) {
                if (pass.length > 0 && !pass[0].FirstName) {
                    var names = this.winresReservationContext.getPassengerDisplayNames();
                    // console.log('NAMES', names);
                    _.forEach(pass, function (p, i) {
                        var name = names[i];
                        // console.log(name);
                        var space = name.indexOf(' ');
                        if (space > 0) {
                            p.FirstName = name.substring(0, space);
                            p.LastName = name.substring(space + 1);
                        } else {
                            p.FirstName = name;
                            p.LastName = '';
                        }
                    });
                }
                // console.log('[WinresTransportWrapper] Detected passengers:', pass);
                this.passengers = pass;
            }
        }
    }, {
        key: 'loadProductLines',
        value: function loadProductLines() {
            var lines = this.data.Products;
            var realLines = _.filter(lines, function (line) {
                return line.IsTransport;
            });
            var transportLines = _.concat(realLines, this.noneRouteLines);
            var simpleTransportProductLines = toSimpleTransportProductLines(transportLines);
            this.transportProductLines = simpleTransportProductLines;
        }
    }, {
        key: 'onChange',
        value: function onChange(valid, complexProductLines) {
            if (valid) {
                console.log('[WinresTransportWrapper] All required selections made.');
                this.winresReservationContext.setReservationComponentErrors('extraservices', 'transport', []);
            } else {
                console.log('[WinresTransportWrapper] Selections are not yet valid.');
                this.winresReservationContext.setReservationComponentErrors('extraservices', 'transport', [{
                    Message: 'transport.error_forced'
                }]);
            }

            this.createProducts(complexProductLines);

            // Transport to session
            if (this.data.SelectedDeparture) this.data.Transport = { Products: complexProductLines,
                NoneRouteLines: this.noneRouteLines,
                DestinationCode: this.data.SelectedDeparture.DestinationCode,
                DepartureDate: this.data.SelectedDeparture.DepartureDate,
                ArrivalDate2: this.data.SelectedDeparture.ArrivalDate2 };
        }
    }, {
        key: 'removeExistingTransportProducts',
        value: function removeExistingTransportProducts() {
            this.data.Products = _.filter(this.data.Products, function (line) {
                return !line.IsTransport;
            });
        }
    }, {
        key: 'createProducts',
        value: function createProducts(complexProductLines) {
            var _this2 = this;

            this.removeExistingTransportProducts();
            this.noneRouteLines = [];
            _.forEach(complexProductLines, function (cpl) {
                if (cpl.WT_RouteIsNone) {
                    // Ignore dummy lines so they don't end up in the shopping cart
                    // They are just so we can store them in session to signify that
                    // those selections have indeed been made.
                    _this2.noneRouteLines.push(cpl);
                    return;
                }
                var line = _this2.winresReservationContext.findOrCreateProductLineByProduct(cpl.Product);
                _.assign(line, cpl);
            });
        }
    }]);

    return WinresTransportWrapperController;
}();

function toSimpleTransportProductLines(complexLines) {
    return _.map(complexLines, function (line) {
        return {
            Amount: line.Amount,
            DestinationCode: line.Product.DestinationInfo.DestinationCode,
            ProductCode: line.Product.DestinationInfo.ProductCode,
            BeginDate: line.Product.BeginDate,
            EndDate: line.Product.EndDate,
            PassengerAssignments: line.PassengerAssignments,
            WT_RouteIsNone: line.WT_RouteIsNone
        };
    });
}

WinresTransportWrapperController.$inject = ['$rootScope', '$scope', 'reservationService', 'localizationService'];

_module3.default.component('winresTransportWrapper', {
    template: require('./winresTransportWrapper.html'),
    controller: WinresTransportWrapperController,
    require: {
        winresReservationContext: '^^winresReservationContext'
    },
    bindings: {}
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresTransportWrapper/winresTransportWrapper.js
// module id = 481
// module chunks = 2